import { nameValidator } from 'wb-spotify/app/routes/superGrid/validation/utils';
import { CampaignObjective } from 'wb-spotify/graphql/generated';
import { object, string } from 'yup';

export const validateSpotifyCampaign = (data: Record<string, any>) => object().shape({
	campaignName: nameValidator,
	campaignObjective:
			string()
				.required('Campaign objective is required')
				.oneOf(Object.values(CampaignObjective), 'Invalid campaign objective'),
}).validate(data, { abortEarly: false });
